export default [
  {
    path: '/notification-histories',
    name: 'notification-history',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-history/index.vue')
  }
]
